export default {
  Title: 'Chuyển khoản kho bạc vào tài khoản tiền gửi chi lương',
  GenerateFromSalaGov: 'Sinh từ SalaGov',
  AccountExpense: 'TK chi',
  AccountExpenseTooltip: 'Tài khoản chi',
  AccountReceive: 'TK nhận',
  AccountReceiveTooltip: 'Tài khoản nhận',
  Description: 'Diễn giải',
  CTDate: 'Ngày CT',
  HTDate: 'Ngày HT',
  CTNumber: 'Số CT',
  GRNumber: 'Số GR',
  CKCNumber: 'Số CKC',
};
